module.exports = __webpack_public_path__ + "img/Sixbar wrasse.2f299797.png";